export const documents = [
    {
        name: "ახალწვეულის ქცევისა და უსაფრთხოების წესები",
        url: "http://www.legionerebi.com/failebi/regulation.pdf",
        format: "PDF"
    },
    {
        name: "მშობლის/მეურვის თანხმობა მონაწილეობაზე",
        url: "http://www.legionerebi.com/failebi/mshobels.pdf",
        format: "PDF"
    },
    {
        name: "სადაზვერვო მოხსენება SALUTE",
        url: "http://www.legionerebi.com/failebi/salute.pdf",
        format: "PDF"
    },
    {
        name: "ქვეითი მებრძოლის შენიღბვა",
        url: "https://paatagigauri.blogspot.com/2020/08/blog-post_23.html",
        format: "Blog"
    },
    {
        name: "ქვეითი მებრძოლის ეკიპირება",
        url: "https://paatagigauri.blogspot.com/2020/08/blog-post_25.html",
        format: "Blog"
    },
    {
        name: "წყალი ლაშქრობაში",
        url: "https://paatagigauri.blogspot.com/2020/08/blog-post_31.html",
        format: "Blog"
    },
    {
        name: "სამოქალაქო თავდაცვა: მეხის ჩამოვარდნა",
        url: "https://paatagigauri.blogspot.com/2019/09/blog-post_2.html",
        format: "Blog"
    },
    {
        name: "თვითგადარჩენის ალგორითმი STOP",
        url: "https://paatagigauri.blogspot.com/2019/09/stop.html",
        format: "Blog"
    },
    {
        name: "სამხედრო სკოლა და ტაბახმელას ოპერაცია",
        url: "http://www.legionerebi.com/failebi/skola_1918.ppt",
        format: "Powerpoint"
    },
    {
        name: "ბრძოლის ველზე დაშავებულის დახმარება",
        url: "https://www.youtube.com/watch?v=tWfC7W2hnzk&list=PL6IKWRcbCF_JzLRz23HJUvf-MW0f8m2oc",
        format: "Youtube"
    }
]